import { render } from "./BtnReprocessarParticipantes.vue?vue&type=template&id=b98550ac"
import script from "./BtnReprocessarParticipantes.vue?vue&type=script&lang=js"
export * from "./BtnReprocessarParticipantes.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__